import { Meta, theme } from 'aimo-ui';
import { Row } from 'components/longTermParking/styles';
import React from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import styled from 'styled-components/native';
import { Divider } from 'styles/CommonLayoutStyles';
import { ColumnWithMargins, RowSpaceBetween } from 'styles/ContainerStyles';

type TicketRowProps = {
  title: string;
  titleColor?: string;
  content?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  testID?: string;
  divider?: boolean;
  onPress?: () => void;
};

const Shrink = styled.View`
  flex-shrink: 1;
`;

const TicketRow = ({
  title,
  titleColor,
  content,
  testID,
  divider = true,
  children,
  icon,
  onPress,
}: TicketRowProps) => {
  return (
    <>
      <TouchableWithoutFeedback onPress={onPress}>
        <RowSpaceBetween padding={5}>
          <ColumnWithMargins maxWidth={'60%'}>
            <Meta
              color={titleColor ?? theme.colors.gray300}
              numberOfLines={1}
              ellipsizeMode="tail">
              {title}
            </Meta>
          </ColumnWithMargins>
          <Shrink>
            <Row justify="space-between">
              {!!content && <Meta testID={testID}>{content}</Meta>}
              {icon}
            </Row>
            {children}
          </Shrink>
        </RowSpaceBetween>
      </TouchableWithoutFeedback>
      {divider && <Divider />}
    </>
  );
};

export default TicketRow;
